// Actions
export const LOGOUT = '@FIL/APP/LOGOUT';
export const SESSIONLOGOUT = '@FIL/APP/SESSIONLOGOUT';

// URL Constants
export const LOGOUT_REDIRECT_BROKER = '/advised-client/accounts/log-out.page';
export const LOGOUT_REDIRECT = '/#';

// USER TYPE Constants
export const USER_BROKER_CLIENT = 'BrokerClient';
